module.exports = __webpack_public_path__ + "static/media/icon_file_download.d8ad5e8e.svg";